import { createAction } from "typesafe-actions";
import { ACTION_TYPES } from "./constants.js";
const setSearchContext = createAction(
  ACTION_TYPES.SET_CONTEXT,
  (action) => (context) => action(context)
);
const setPartialSearchContext = createAction(
  ACTION_TYPES.SET_PARTIAL_CONTEXT,
  (action) => (context) => action(context)
);
export {
  setPartialSearchContext,
  setSearchContext
};
//# sourceMappingURL=actions.js.map
